import { useNavigate } from "react-router-dom";
import react, { useState } from "react";
import { StatCards } from "../../../../_helpers/StatsCards";
import { Button } from "../../../../_helpers/components/Button";

const EspaceBilletterie = ({ donnees }) => {
    return (
        <div className="bg-white p-4 mt-6 rounded-xl shadow-md">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Espace Billetterie
            </h3>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left text-gray-700">
                    <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                        <tr>
                            <th className="px-4 py-2">ID See Tickets</th>
                            <th className="px-4 py-2">Places réservées</th>
                            <th className="px-4 py-2">Places vendues</th>
                            <th className="px-4 py-2">Nom de la structure</th>
                            <th className="px-4 py-2">Nom client</th>
                            <th className="px-4 py-2">Téléphone</th>
                            <th className="px-4 py-2">Commentaire</th>
                            <th className="px-4 py-2">Nb personnes total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {donnees.map((item, index) => (
                            <tr key={index} className="border-t">
                                <td className="px-4 py-2">
                                    {item.idSeeTickets}
                                </td>
                                <td className="px-4 py-2">
                                    {item.nbPlacesReservees}
                                </td>
                                <td className="px-4 py-2">
                                    {item.nbPlacesVendues}
                                </td>
                                <td className="px-4 py-2">{item.structure}</td>
                                <td className="px-4 py-2">{item.nomClient}</td>
                                <td className="px-4 py-2">{item.telephone}</td>
                                <td className="px-4 py-2">
                                    {item.commentaire || "—"}
                                </td>
                                <td className="px-4 py-2">
                                    {item.nbPersonnesTotal}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const HistoriqueModifications = ({ historique }) => {
    return (
        <div className="bg-white  p-4 mt-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
                Historique des modifications
            </h3>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left text-gray-700">
                    <thead className="bg-gray-100 text-xs uppercase text-gray-600">
                        <tr>
                            <th className="px-4 py-3">Action</th>
                            <th className="px-4 py-3">Utilisateur</th>
                            <th className="px-4 py-3">Date et heure</th>
                            <th className="px-4 py-3">Détails</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historique.map((entry, index) => (
                            <tr key={index} className="border-t">
                                <td className="px-4 py-2 font-medium">
                                    {entry.action}
                                </td>
                                <td className="px-4 py-2">
                                    {entry.utilisateur}
                                </td>
                                <td className="px-4 py-2">{entry.dateHeure}</td>
                                <td className="px-4 py-2">{entry.details}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export const FicheActivity = () => {
    const [activeTab, setActiveTab] = useState("info"); // "info" | "participants" | "historique"
    const donneesBilletterie = [
        {
            idSeeTickets: "ST-001",
            nbPlacesReservees: 5,
            nbPlacesVendues: 3,
            structure: "École des Arts",
            nomClient: "Marie Durand",
            telephone: "06 12 34 56 78",
            commentaire: "Allergie au gluten",
            nbPersonnesTotal: 5,
        },
        {
            idSeeTickets: "ST-002",
            nbPlacesReservees: 10,
            nbPlacesVendues: 10,
            structure: "Collège Jean Moulin",
            nomClient: "Luc Bernard",
            telephone: "07 98 76 54 32",
            commentaire: "",
            nbPersonnesTotal: 10,
        },
    ];
    const manifestation = {
        name: "Atelier peinture",
        manifestation_id: 1,
        id_readable: "MNF-00123-UIUFHLIF-280525-1330-1530",
        image: "https://source.unsplash.com/800x400/?activity",
        dateDebut: "2025-06-15 10:00",
        dateFin: "2025-06-15 12:00",
        lieuRdv: "Parc des Volcans",
        regroupement: "VG Groupes",
        langue: ["Francais", "Anglais"],
        precisionRdv: "Entrée principale",
        accessibilite: "Oui",
        quotas: 20,
        tarifs: ["7€", "5€ réduit"],
        date_billeterie: "25/03/1995",
        agentAccueil: true,
        canauxVente: ["En ligne", "Sur place"],
        circuit: "Circuit découverte patrimoine",
        precisionPublic: "Enfants 6-10 ans",
        typeVisite: "Ludique",
        public: "Scolaire",
        multimedia: true,
        visuel: true,
        intervenants: [
            {
                nom: "Jean Dupont",
                langue: "Français",
                phone: "06 00 00 00 00",
                publics: ["Scolaire"],
                preparation: 30,
                photo: "https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs=",
            },
            {
                nom: "Jean Dupont",
                langue: "Français",
                phone: "06 00 00 00 00",
                publics: ["Scolaire"],
                preparation: 30,
                photo: "https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs=",
            },
            {
                nom: "Jean Dupont",
                langue: "Français",
                phone: "06 00 00 00 00",
                publics: ["Scolaire"],
                preparation: 30,
                photo: "https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs=",
            },
            {
                nom: "Jean Dupont",
                langue: "Français",
                phone: "06 00 00 00 00",
                publics: ["Scolaire"],
                preparation: 30,
                photo: "https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs=",
            },
            {
                nom: "Jean Dupont",
                langue: "Français",
                phone: "06 00 00 00 00",
                publics: ["Scolaire"],
                preparation: 30,
                photo: "https://media.istockphoto.com/id/1389348844/fr/photo/plan-de-studio-dune-belle-jeune-femme-souriante-debout-sur-un-fond-gris.jpg?s=612x612&w=0&k=20&c=VGipX3a8xrbYuXTNm_61pFuzpGdAO9lwt2xnVUd7Khs=",
            },
        ],
        disponibles: ["Alice Martin", "Bruno Lefevre"],
        indisponibles: ["Alice Martin", "Bruno Lefevre"],
        contraintes: [
            "Prévoir vêtements de pluie",
            "Pas de toilettes sur place",
            "Matériel physique nécessaire",
        ],
        description:
            "Une activité éducative en pleine nature avec des jeux pédagogiques.",
    };
    const navigate = useNavigate();

    const Info = ({ label, value }) => (
        <div className="flex text-sm">
            <span className="font-medium text-gray-600 mr-1">{label} :</span>
            <span className="text-gray-800">{value || "—"}</span>
        </div>
    );

    const jours = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
    ];
    const mois = [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
    ];

    function formatTitre(dateDebutStr, dateFinStr) {
        const dateDebut = new Date(dateDebutStr);
        const dateFin = new Date(dateFinStr);

        const jour = jours[dateDebut.getDay()];
        const jourNum = dateDebut.getDate();
        const moisNom = mois[dateDebut.getMonth()];
        const annee = dateDebut.getFullYear();

        const heureDebut = formatHeure(dateDebut);
        const heureFin = formatHeure(dateFin);

        return `${jour} ${jourNum} ${moisNom} ${annee} : ${heureDebut} - ${heureFin}`;
    }

    function formatHeure(dateObj) {
        const heures = String(dateObj.getHours()).padStart(2, "0");
        const minutes = String(dateObj.getMinutes()).padStart(2, "0");
        return `${heures}h${minutes}`;
    }

    const contraintes = manifestation?.contraintes || [];

    return (
        <div className="mx-auto p-6 ">
            <div className="flex justify-between items-center">
                <div className="m-2">
                    <BackButton
                        onClick={() => navigate("/activity/projets")}
                        title="Retour"
                    />
                </div>
                <div className="flex items-center gap-3">
                    {/* Modifier */}
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-gray-100 transition"
                        title="Modifier"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
                            />
                        </svg>
                    </button>

                    {/* Attribuer un intervenant */}
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-gray-100 transition"
                        title="Attribuer un intervenant"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M18 9a3 3 0 11-6 0 3 3 0 016 0zM3 20v-1a4 4 0 014-4h4m4 0h4a4 4 0 014 4v1M6 9a3 3 0 116 0 3 3 0 01-6 0z"
                            />
                        </svg>
                    </button>

                    {/* Dupliquer */}
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-gray-100 transition"
                        title="Dupliquer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-gray-700"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2M16 8h2a2 2 0 012 2v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-2"
                            />
                        </svg>
                    </button>

                    {/* Supprimer */}
                    <button
                        onClick={() => navigate("")}
                        className="p-2 rounded-full hover:bg-red-100 transition"
                        title="Supprimer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5 text-red-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M19 7L5 7M10 11v6M14 11v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200">
                <ul className="p-0 flex flex-wrap -mb-px">
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("info")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "info"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Information
                        </button>
                    </li>
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("participants")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "participants"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Intervenants
                        </button>
                    </li>
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("billeterie")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "billeterie"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Billeterie
                        </button>
                    </li>
                    <li className="me-2">
                        <button
                            onClick={() => setActiveTab("historique")}
                            className={`inline-block p-4 border-b-2 rounded-t-lg ${
                                activeTab === "historique"
                                    ? "text-blue-600 border-blue-600"
                                    : "border-transparent hover:text-gray-600 hover:border-gray-300"
                            }`}
                        >
                            Historique
                        </button>
                    </li>
                </ul>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-6">
                <div className="flex flex-col md:flex-row items-start gap-6">
                    <img
                        src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBxMSEhUSExMWFhUXFx8YGBgYGB0aGBcaGBobGhsbGx0YHyggGh8lHRgYIjEhJykrLi4uGh8zODMtNygtLisBCgoKDg0OGxAQGy0lHyUtLS0vLS0tLS8tLS0tLS0tLy0tLS0tLSsvLS0tLS0tKy0tLS0tLS0tLS0tLS0tLS0tLf/AABEIALcBEwMBIgACEQEDEQH/xAAcAAACAgMBAQAAAAAAAAAAAAAFBgMEAAIHAQj/xABJEAACAQIEAwUEBgUJCAIDAAABAhEDIQAEEjEFQVEGEyJhcTKBkaEjQlKxwdEHFGJy4RUzU4KSk9Lw8SRDVHOissLTY4M0s+L/xAAZAQADAQEBAAAAAAAAAAAAAAABAgMEAAX/xAAtEQACAgICAAUDAgcBAAAAAAAAAQIRAyESMRMiMkFRYaHwBLFCUnGB0eHxkf/aAAwDAQACEQMRAD8A2oJbF/L0rT/m2KuRWFA8v4/jgll0tjFI1xIjRBsR5g9D1xfqFAjd0rlnklPskRJDKJPI82hMeijYTj1KViPLGeeNS7Kp0CVyhDIvicaW1Akwo+qpjxyBZWuRAuYggMxmQ+fSkDpR6ZJUt40NNzc/Z1pYnmp8hiXMcFzGWapXy1WoyFCO7ao7aNmJW5mYgcwTzGwfsWlRsylSskUyGHeM/eeNwiQ2pixWKa78p6jHRxJRbb9v8iuT5JUO/CxZVVQLHTVZpEbgmI1BixuR4fFyvjYZcU5ZFV1VIJZoSS2qByAm8g2geYxdfLAgNUVQwDaadyQdpBMEiIkkiJvvOPMzV7tNNUzpVdKqpAPIAk7rMCJOmOYxld39SoC45QFViivqM+LR4TA2pwbavaJnadMjVjzKaKlTuymiTKaoYMy3MfsiBA3IBHI4vtSejKtbWSzQk1JAOpgLxc2iLHSeRFDMZEEjxBJICbFibkNIMgyZMzHleXxyUZJvoEouUWl2E60uhUDxgmxMl2EAyegt6+HkxBn4FxL6Pu3b+bqBlYDbVZ0X9m4PnbrIo5iszJNhVU6KoH1gSYZfIkke9hOxxTrZju1kaobfSPEZDQonnM+l5iTHqvNFLm/+nnRwyb4jRx7tWtMEUQpZRBO6IQb3tqswm+zHm0YS8zma2YqgnW5awLU9RIb7Ccv/AOdsW+FcCq16g1WQkiSxKIw8TQBZmg7yLHlsX7gPDKVBStNfELMxuxO/PYc72jYXxOMcn6nzSdR/PyyrePBpbYo8M7EOxDVyqBzvu8wfCIOkA3sJ9MNWW7L5anGpTUPWoZk77GxA/dwarUyV1ExpOqbza589pgWwKzPafK0iQW1QJIQatO0g6bTM7nljSsWLGrf3/P2IPLkm6X2CeVoIi+FFQagLDTYMP3d56Y9onUVhgNybKZ3EbmMJed7bUqoNNaIKtBLMZ06TIOlASWEC07xty8o9uHVdSUKYUKAoBMR4ogyIsNoxzzw6s7wpvdHQlgk7EaR06+RwOznCMu48dFPWIa/7W/8A1YVV7dVJg0QRTgmGN7WkDVp35nF/Idt8uYVldWItaduR03n3YHiQfY3CcejXifYem5HdubyNNSXQi/nIF95MYUeK8CzGVBLKQDsQupT0Ia5Q3O/wx07hWbSt4qdRX8JB0nYE89rxFiOeCmYYaGkAiIgiQZ6iLjE5YYS6KRzSXq2ct4P2wqUitOvrcWuV8a3BkG+sG3nI3OxZONcTp1EOZpVLikRTI2h7MR9lwqm/KSD7JwA7R9k0KtWy4I8WgUtRBJJC+Aib6iRG0dNsJmW4nUypIbWdTeJCRBIMNPNXBAPwt0CcoPjLoDhGS5QG/LVRSomqSJcQJEAqAfC4+qY1E/1x5YT+09FDoaJqv42UkCEGxZuTW35w3QYIcQz6uVbUe5F3EQTouFjkdQUf6SV7iLszkuQXcaipjQV2VVY7QI+HmcUySVbFxRfLRQo01NWZKLq5+KNXTlDAW6QL88b1oqQIUDT4WWdMpJnyAEnY8zi3mFgd0stzYEAloJuh3mDaxgepxZ4bkXc9zTJDnUKhKyijwieg6gcyTyF4tf7Lo84fwxqz90oUhWVqlQWK2sYF9VzpFrEkjo40silFFpU1hVG34nqT1xf4fw9KNNaaDzNrkndj5nG75fEJTtloxpCxxKuQSo35n16fnhb4nxRKCksbnZeZ/wA9cM3aCnFQHqPuP+mEPthlC7Uo3Ph+JxqglRCfZJ2czz1mqO/7IUclF9sXuP0SaDAC5iPUnEvCOHCksdY+X+uLtRbT0vgXs7joE5bhAVFW1hjMWm3xmDYKHKlbfBXh68sC0FsT5CuVYcx0xCaLRYyijKj/ADyxIMpz8scn49mKqZmsoq1ANZIGtoAbxARO18W+yXEKq1z9I06CbknZltB33xywNq7F8XdUdFehE4F57gKOCUARjdoA0uT9rz2vz54I5PjSVBFQBH6/UP8Ah9/xwRqUMSlD+GQ6l7oEUEc6KgBR+78bkAwVGmASbTAaR4TznViOopqHSAy6RqZmMEuRGr94LqIEne1gMEzytKyJEkAxMTHrbocUcxlLM1ixJgAHw+MQW2sAE58uuITg1v2GTsG1GFw9lbVDHxMy6hC7ABbxG4tykiajlEXu2B0kN4lPsyBADMZMhjFomYg4mz9FwrM6MSfabw7azpBU2W3M2uJi5NsKJKEQAbG0aogiF9preQB98SknZRNUBM/RCEVWaF3JAJ1T4rKBdS2iJN7eUwUcg7OTUBA2uxPdg30gRF9yfJfIYJ5xYJV/ZFrn617OxJMASLcyfUUci/cVGR57pzD7ypGzi1iDEjeI6AYrh4uSUuieTlxbj2XeH5laBbL+ypEobeCoglGv8D0kc8Gc72go5dA48TkSVB58id4EE3N/WICjmZWWb21OldoMEgafgbf6mfg/Av1g99VaKZYKVBYkEjw7gCDBXVpvBAAnHp+M0+EO/sjAsSrlPr9zXMZ3OZ93RA2kx4RqVAP2pjcGZcjYADBXh3YVTfMVJYW0oAYsL6mW0j7KjffDTlVp0aOy0UQSRZQPOT16yTfc4XuLdskQsKFMuQBJaQJJ3AAknly3w/hRjubtneJJ6gqRazvZyklJu4oBqgpto1S51x4SpYkAgzFgJM8sFOG8OAAlKakwTopqCDpQEEMtpOokRaT64T17RZ93ZkOpkKlUSnYhgbGJc7jl8BfEmZyPEKjVW/2iWIKQxUXmdILLp5Wttzw2r0gVL3Y85jhtBgddGmbWlF3AJOwkbYFZ3sllXMhCloBUyI6aH1LHlGFrN5DiC96VbNfV0eNmH7UABvTb88bN2nzdE1BU01Fpso0spRjO90J87kfwDr3QVyXTJa/Y/MUir5arqAYmV8D2IB8IsdjsRPTG+T7Z1ELJmlMBtOvSQw5+JdIB5dCRyOGPgvarL1JRj3bggEP7JJ5K2xvblfEXajhVLMa2qrGhZFQDxeS/tA38J68sKoVuIXNP1EPGM0i01r0mUpTQsl7d40IHJO+gFz1nfCPx7gC1Ka1kX6Y7ptrEQNtnAg/O42pZt63D6po1DrVmuAxKGNypfmCY3tpvaDiXO8a0h3RvEyhKQO6TOtyOWlYAHItbeAyal2K1KLXEUzqtqLaplQ0wdx7V7hgLH5SMTVMsHCio8FUaxkHkyhh7ztYkj0xGEEazaPYFjJFySCBq8+fi6C1zIZVqhEAszyEUG2xBIJJgCxg+vrBq0aloh4Lle8Pd0wHck2IICgi7hhMcifWBc26RwfhC0kCAkndmN2Y+Z5DoNgMa8E4KmWSBGowajxAJj5AdMUeL8W1nu6Vk2J5v+S/fiW5eVD6jsv8A8uZMGDmaQIMe0N8WKOeoVtQo1adQgSQrAkDqYxxhmkserE/PDx+jLSiZuqxsFRfWS5/DC5sCjHkmCGVt0T9ovq9Qx+f+mFbidejTdXqsPAshRdmY2ED01X2xe7RcROirUUwRcc4uBjnFdyxLMSSdybk4040+NMnN70OXBuNNmXqeEKiBdCjcTMyeZsMFHFjhX7E+1W9F+9sNHIjAlqQY7RSYXxmLBp/5jGYAQ8K5AB5Ygr8V0ONsearx8PywtcaaGJ5/lgLZ3QY7Y5RqeaOvSSyK0qTBEaZuLextf1OK/Z0xmE8ww/6Sfwxnb7jKB6LsCSUK2j6pnn++cAOHdqEWrTYU38LT9WSIvz3icaKpURvY48Y7Q08rURKqnSwPjFwPUbx54ZuF8ZZV8JD0/sk7eh3U+XywqZmll+I5apoIaqgJUGzgqJiDeCRE7YIceymZekKmSRmqKQSUTVqUAyp+1yt8MRl8NFF8j7ksylUHSb8wfaH5+oxtVpR9+Eo516FKnUzQ7liF8RDIFdhMHVdbyJk+cYZ8hxwMn0xEcqgvM7SF39RiTxv+HY3NLsFV+GNRqd9TJaDqvc9W1fbBEj3+/B32QREiSqQOQKhR6bEtva1vZsVkBEgjpIxCX2DXAPrygD0ubYzSxabX/hXnYMzICgIYChbGbDbmORk+Lcxbyh/VwAVe0Czbbbg9OvxkmwxYNenrNKTbeRAsLgGZ28ogMRvJ2zaQAhjTvttFgPSfhpIi5nO/z8+SqBXB8olSsqP4W0kU1+q0bITvLCSRA6DE+ZzPj1zC8l2kg2kbG4sOR5bRvTyZPjLLMGL3swIYnr4Z1AzzubmhToPmnKgkL7VRoEqZAMAbkyOsSNrxt/TZtcIrZlz4vNyk9IxnzGfqRciCD9imeRO0bDrPnBAZ8h2ToUl7yrFQhQCz+FIEfVM6tudrCwxPl8q2WUU0ph6jXSkIsN9dTlM8/QDF3KUBUmpmfpdJkWiikKGlQd4n2m6A49KMFHb2zFLI3paR5R4rTI0ZdWq6bRSWKakCYJsFtHPG/wCs5l2gZbSy38VVdmmB4Z5fdi7kaoFSvFJh4lvvq+jUTE+GAIjynGUM4f1iovd1LU0P1Yu1QWvM2+7zw9sVJFd89mVJH6qTETpqoTBO8GDA0nENbiWXrEUayqrm4p11gmDErqEcjBB+7BdcwdbfRv7K9OreeKVeohrsKlGzUlUlipDS7AIVJjc789UYAegJ2g7E02UtSOmX1srGQ3lJNt+c+o3Clk+P5jKE0KysVJLaW3pBbqRy072J8xYAl24hRq0WC5UGGU/7PUK6H0xIpktNMwdrrtYb4Ecb4eudpVKsaCoYPN6lFlOxH2PDsPMg4Hh2tHPLumB1enWod3UcFIaqaouaaqPavzvF95Nsc+pIJi4AFzsSBfTAJHu+ItOCGaqVKLtRNjrANOxB0kESekhTz2E2gYHrSJhJBBuNNyxkgCObSB8fjnyyWlRoxRat2WKaa2UgTcKiD6xFwN/x+UnHQeznBloK1R47xru3IADYGBYdYEm/QYpcC4P3CGpUjvCI8qan6o6nqef3w9qe0CUqepidA2Ubs21/f7sSacuui1qPZa45xbUNK2p/Nz6fcMJ3BOLtWrV1K6VpQB1kapJ5chjcJWbiCamlFo6oHsqXJFuu2588Q52smWWqKelqtV3ZuiA2WY3McvPDwXshZP5ACAxhn7LUWOWzB1hE1CYuzFVJgTYDxb392+OeLx2pHsp8G/xYauzWcepQ0KJeo7AKLSYAG5ttuTizgpaZOMqdkOZfVQq/uYVKmOop2HYZdtWapAlYOlS6L6sCCPXT8cc14llGpVGpPGpDBgyOoIPMEXGFimM3YU7Fk66v7q/ecN2kjnbCn2IX6Sr+4P8Auw1s2Jz9Q8PSeTjMamMeYAS6OIrMspHpcfngHxzS91IP3/A3wIy3aeY7ynPmn5H88W3zFKopCuJPI2PwN8XWKHsZnlmu0VO3TyaPlr/8MAMgpLqAJJNh1PTEvEahNOnJJIepuZt4LXxb7JqhzdHXEBpvsSFJUH3gYZjLY+cF7GU0KValUu6NL00EKDBsXUzY+k+mOoZLjEqAFEC0AQI6DYfO2A2S4qEQaU8Fw1MGmJMzMMRve/p76OerUmBq0aq0nmGRmifSZB6fjgNgHfNvSqr3dVVqUnF1aGU+UHCH28yZySLUy4+iCmVMkBqYVkDczZWht+RJx7k+Ot7FTlvt/k4u8drpmctWoMRDUzfoRdWjexg+7C8ldnOLqirT48qVlpuwR6id4Bcow53iAR5/HB/KZxXIBgEn3H0OAVLIo/c14+kprE/sOlx8YPxwJoZGvlFpoCai/rJRyxJApPdCt7RKi1r7dIPzF/SdDrZESGIuux5jAzPlUPiZQHNgZvyGwMCN9wJjyMdTthSpFcu1Jyw0qWkRLBb3v9bFLiNBDmO+ao+koECR4BBJkTs1z8vLGXLh1df7KwyW6LXFn00wLARv9mLQfLn6A7zhf7PZqo2YLUvaXwsPtFjC7mDJN7+/Yi/2nzq90a0nQDpchZg8ufoQTHtEetvsR2YWrlwWc3ckMsqxgQZI3AU6R5semD+n/Ty762LmyqmBeL8UzNPMtqqw/tShMMJccwDAGkRtYHniFeMV9JXvng2I1GDaNp6WxN2r4UmXzIRCSNLXNzutpN4H44EzfGqcmpUnojjhFxTaVjn2Qz9ZhW019LDSzaoMn2b6gbwB8MGBxHNFin6zTERB0CTIkyY5QYgepwiUmjJ1zJU60Ejf2hb54F8O0nvajVgNGmEY+KpqAEKRtG58sWU/KrIygk9HUqVTNd7UH65TsqR4FuCX/Z3thI7S8UrLmagNdmZGiQYspBWwsLyRgUvEqAdjFT2F/wB628vz94xHxSoCysJhqam5k3nc8z546UmoghFOW0Wk4tm3bUc4UK3DM7Qoad9AbSfUcxg/2Rp5ivQd0rA1kNSnfx94iLT+jJJAI1OxUnmehwt8CqU48Y9msCPEF1h1ClTY2BVTPnE3w49j8tQRqlPxooeoQveMNJ+gNisar3B6R0wuCblk42PnxxjDkkjmXFGJZi06zck7ovnP1ibnz6YduxvA0p0lzVXTOiV6IrC0dXb+AxU7Z9nTUr66JXQ8s8kk94CQ0lrkGNQ9TiGtx5jlGytOnFWinheZDMg0exFpJnc4GeDuh8M9WXeN8YAemkHx1NKDoYJlo8gbf64X8lSOeyzLUIn9YuYA8KVC0GPIR78EaHCArs7XPfGso3v3YpCfgx+GIOydAJTrAGf9oq/JyPwwkX5XX0KOO1f1CwQAkgXMAnnCzA+Zwh8SqTWrD9ph8zh8YyMIGfT/AGit++33nBxN2Ga0I6bYdOwbeKhLaR3xk9ABJ98ThLUWwzdl1c/qwpprb9ZgKSQLrEkjYCZxoZnOrZmrlCspUqh49smzEdQAPkcc27c1apr91U2pewYuwaCx/tAiOUHHQP1BErFczUWkCA0yCDeL7AYs9r+GZfiFMrSeka6AmmV8J66SOYMfjhI7Hemct7HSKtT/AJf/AJDDY4wp9lARXqAiCEgg7ghwCD6YbKuJT9RSHRGRjMezjMKMJfBeHGq4UWHM4cu0HDKVHJVAqCdM6iJYkCZnFDspR9n3YOds/wD8Sp+4fuxZIjJ6OT1a7uAG+rt79/uGDfYrKmpmY5imxX1I0A+7XPuwJ4blalcrSprqctAFpvzPOBczyGOodnOzK5JGctrrEQ0DwqLEheomJJ6DbbFK0Lfua5hu7Yo7E8pImeUkTfGokiEXVcXbf4dfM43zml7mDeeuLHDwWEqpYggECTczAlet/wAsZ5LZSLPEVrBn8grASPQjfFDtlnGpUO7hgait4tXshSsgeuqOXPDBR4aVcNUXSwMlSIPly69cLf6STal+5U++lhI+pDS9I95BvCo8gPlgB254rVy1JHpNpJqAGQCCNDGCD5qD7sG8m3hHoPuGF79Ia6qFMf8Azf8Ag+BB+Yaa0UO0/F6K5tiagBim0GZ/m06DqDhkp5yqstK16LNUaRBgGqndqCNoR2kH7HLHJO0FXvaorBkIhVIDDUpAggqYO/MAja+Oh8L42Mpl6GtVNKpVqq7SS6wWaQoB1CAZ6SMXnH4JJq2OXDSvd5rQBcnwtBuKSiCLgi3ni72Sqj9XompQpNqAJOkSoZiSfZOqxB5bYTOPada1UMB69NieRDFb32EAY84fQarAWuaYVKUQiMJNMC+oHYg/HEIycZ/2HlFSjTXuXe3JQ5od0o0hW9gWnUv2fT5YXoP2T8Dhp43kKWaYUcwe7qBSRVRuWoBVYRBU6ibm3KJwm1uySrUdNFVmRoYrJAnbZdiLidxhpK3YsXxVFziVQLkawa30ie0PMdcAuEGixqTUVIpkrCzrMWS22rqbYn4/qy9FaADlWJZg48VvZNwIAbAzg2cKOW1JqCsPFT1qfCQbXGxkH0OLRi+Gib3IpZrMUwTAU26euGvUWpUSBI7hNhbY4W+I5BhQGYBWGqtSItuiK4gTexN+sYKHJ0q1KnqdhoUIIePCNiQDBP5YM1oEdMu0cwqAd4RBcQl5YjkIHUiZIsDh24bTZsrnMx4e8TVBZVY3CG2r92PecJlXhlBE0UWJRWDq1QjUQwAMWEmWBtFhzviWhnCU1K8K4OoWidB57g7WnnjFyak3H6mtxTir+gbz+ZqMAFhBo1OwhQJRydrIAyi/nhMXj6Gq3dOQ0t9Ui2qeY8hhvq1P9ieIulT33f48scjyX8+/9f78acLtWyOVV0dqruLR0wI7NVgyVo5Zip83JwTF8L/YypIzE/8AEP8AecSg/LL+xaS2g8WwjZsk5qqqqWYu0BQWO/QCcPFVsA+yWs5zOBdUnopNgxm42uR6+7D4n2JkWjl2ZylSkdNRHRonS6lT8GGHD9GVENXAYhgEd1QG6t4F1MPRjG/uwU/SGjVP1fLaS+Ydi6giCFgrEmImJPIaZOLfZPs82TU63pmtUhmVSSVpgSBqH2mN48t+VpS1ZFR3Q9ZqooVZUWE3F10bC/PEfFuHGpRXN0Z72kPFAMsgubxBIN9zzGNKHEaRZA+UKhlkEmUOwuJmdrG0csUeNcQJJKKFKgqdIA0jTNwBcRBEc7Xx1h4gHjFGk+YGapAKzqyVQBAZgwIe3M3k87YoZmoREG8jl5iflOK+TzYfMOg2pIB/WYyfkB88TZg3H733An8MRm7kWitGX64zHgbGYBx52ctB6Rgn2racpV/cP3YRuwua0s6dYPw/hh6q5Vs2BlUIDVfBJ2E3JPoAbY0VszvaCn6LezCUKC1XtUqjUZAkA+ytx0gkdcOXEeD6hI9x+z5gTY+YwK4bX02bwBbGbR6dfQYYKOdMWpu3mRA90yflg3Z0uxC4xwonVaOSnZiepMbbcpvgfwylVyzaVOoMwkm/s3tb8DHnh+4kiuCTScTzgb+WzX8hikOFo9lqQdtLWP8A1CZwsqZytGmXz1VjFRRUpGAVa8W5ERpb0j3bYVv0l9nj3C16RL0kVw/26espdhzHh35cwMOPD8iQAWEMLOealec7xzgb2wTVCplvEhkGRaDyPJo2m/TC8d2G9UK+SuqxHsqfiLYA9v6Z/V0P2akz/wDVUOGntDw1srTavRWaCpMAEmnpFovJX8t+eEarxDMZrLBBTFZpSoGAlCstSqJCwdShriQfEI5EyWNpluSaOfpU7xXDU5qCCHUR4QdjETYkzckDyw4cZ4ZVrZXLIjGHquoUkBdepze0mV1TMxoEC5woZTNOjE0yihg31V02iP5wbTfrfDZV446igEpV37qq9QkISpDiyjVzBkzHvxed2qIxSp2FzVR+HUWqEKPAjBvDDICjC/mptiHgnHKNE1KVNHY0xJVVNu7aDHW7YFcX4ytTLMgpVqRau1TS6GD3mpjciLMZj4eU3CMsKWcbNsA4aozqpEe0+pTe4MciLYlJwivOVhCc35BgztQni7XIDZNyVnmAdx1FvhhsyOZVqOZC0yGp1nQsrEWUDSR4psum3rhM4jx5cxxJGioKhy70wpgg61YggrBnwxGnphg7K0a65eqtRHNSszVVsZAempkt13HmQfcPYAn9suFNma+UbvQe+HdqzE3KlixtuoVhBm5B9cKNZHQVGBVlDqvtICShIOpJJVZFiRG18Fzx1kfKd8bUmNdGUSe7qmylWtIhtpAsOsB8jRp1ajg6tMMQBC77TuIBO0cuXKqfFbEq3oJJlxVyKhAzac0WaCDCsihtKWiNINzyJ2vgnw/sGhzrUqtVe5R4uwVnGnVpPmSdJCiedt8A+y3ElopXp6CxemStgQpAYMWn2RpMahBuBzv0FeMZsgL3qETIBooYJEGLWJBO2EyZODoaGPkgb28pMDSrLS7ulfUNUjSo0o8AeEEWA6TbFTL1lr5aojgvUWoArDYoVnxdYEAc/hgs1Cu0lqqyeXdLH8PdiMU6qzFVRO/0YE+sHEF3f5+xV9UbUHU8PhSCO6qAR5FxjmOQQms4HR/xx0JMrUp0u5VxogiNPJiSb6p5nCXkaOjNugkqWgGOZYD8Ti+OlZKaejrOggXj/Jws9hwIrnkcw/yk4McTz4pgs7qqjmQYvEc+uFzsW8ZYsGI1VHNgPTmDiSri6Kv1IZKp+8fdOHTgXDzTRXC9yrnUFC+JpvrqE3LHpy+QSchRD1qaFmMve8WXfaOQx07OZ6U30k7TECPXcYpjJ5Adx1qT03pglXIs8+KOccpHMdCDhfzOcplV0LBBl5JLFgI8RO/keY9MTZ/OCpzi8MVh1B6KWG53AEkT9UScB85oWpAVke+q50taRHIxIv64eXQIljLUkHsgAtLnz09fdgVxp2CuwkmIYASSoUN8o+ZxdFbSyL5fPS1viVxSz/EmoirWAlVgn0AMx1sFwI7C9CL2Qdyaz6dRYiTIAk6jz9cHai1Cy+FRcm7k8iOS+eBvZN5Ws8RrqkgdBAMD0nB2mfGP3WP/AGj8cTm/MPBeUr/q9T/4/g354zF44zCjUcy7OZjRmEPInSffjo2Wy9SrVpJSJVzUGlhbTpIJa3QAnHKEaCD0OOtcPrt3Rro+j6IksDBg6bAjnNvjjVN1syx2FOL5nNK/iqvYEagAG35GOY5zNvhQpI7tClyTuzuSJ9CL+mF/h/F6lTUtUvJaVZiTI6SeY/HywX4dnqi2KkqPrDcfn9+IplToXAODOoE5l5/dSPiFB+eD2d4S5Tk9uQgj4kz8T6YTuDcbEC8j1w5cN44pFzbr09cWVNEnaFqhnKtNiqm0xJEx8fLl5YNJUU0zsWZYnntb8MEuL8JTMKXpkCpG/JvXz88D6HC6ole7ICoTJ+s0WVfS19sTSa0FtMj4VxYFQ0yCMU+Ndj6GY+konunJGoLsb7gAjS2/l1F8CODdl89TzNZTVpnLs5dJklASxYAEA2MRPhj4Ya69Y00ampMBLmPEWvJ8p/DHNKXqXQyk4bi+yhluEUaV6YA2mobu5gCSx8TWCge6LDHvFuALmUmO6q/VfmfJ49ofdy5g3stYKYm0gGwA5sfiFHvxb1PI+rPPTqqseiKbIB1PvAw9KqJttu2cuXK1EqmlWou2mxHdl1mJBBAg+R88Ush2VzBNUwolyU1EghCZAIixAx07tJ2eOap/zrrUX2StVw09GNKJHlsMcyrcNdWZTVzIZSQR3uZMEe/EMsIvUjRgySg7iZR7K5qnX79dPeqCFIqXghhAGiJ0k8/fzwbWjXFhl8xH/NEf/swvvkKn9Lmf7zM/njZcnU/psz/eZr88c3D5B5i1mex1SrpmkgUDwo73WQAbKrATpGxx7k+x9aiS1KnQBIg7G39eicVTkav9Lmf7zM/njVslV/psz/eZr88U8THVOxeE/Yi4l2VbL0MxWNJAe7bxU2Hh1WOoFVkGdgD7sEcusARvGAvFctUFGoTUrkaDZnzBU25iodPxwbG0YllcZO0PC0tkhqCcQVXnnGPGAxBUScIhjao0/HC7lKsOrQSBUmwkmHJgDnttg66+eFzhXFaFGrTd6hBSqHKhWJgNNiLTGFnFtL+pXE6b/oFO1WepZjK1DTqBj4SVIg2aT8hiHsfSY5WnBAktuDzaOuCmd4zwzO6tRCubaiO7e/VgIa32pxe7OdnKSSzZmo9HdFpimsDchnY6ZJ6b40PjXFEOM75NFjsxlHfNLIlVDElQfD5mTHWOpjDZxPMajpgRyVnlfcpGpfccGOG5FVQpRosiWJDAhjI31k+Iz528sVM3wclge7Y6TNxNjaRG/mImDhowpE3O2CWohVLuQSBCiQIm3hGw3wC7Tlg9OpEeMc+UEH4ibYZX4IFT+bjS3ggEWje22/PmMBM9wR6rGCEUkEsxj6sbHxHnyw7WgJlLOobuDAVSBPNjb+A9MLnFsw36lmTpkaQCbiNXh6e/DF2py1XVSFDxeLSRzgCTEN4Zjc9MUu1PDaz5Z6WXpEsFRSFF2B9qTzgCOt8LFUxm7FPss4WgJDXdjZGI5DcCOWCtLNIHJJItF1I3PmPLGnBcjVoUKaVab02uYdSpux674lqHxH90fex/HEZeplIvyo2PEKX9IvxGMxHqxmOoNiOMrVewpoD0CLP3HDRT4jmgqotKhTpgeywSDHXT4vuxPmMqtOjUKKNQRiPUCfwwltxGqfrkegA+4TilOfYsMigmqOgcFzdSu/d5gUihZQBTWAhIYg6oB+qBhkGTmmiqpB8QMCSORP44Rf0ZnXXqo7ElkBBJmNJiZPTUMdD4jkXYalqMjD2gNmjnE9MUUaRKUrdi1n8jXoEFIjz2Me/FnKcXckKGhuY3v0HXbEteVBRu7a0nTqDn1UKx+eKmSydV31UqJUgGGqHSLWsFk7kbwfhhHF9o5P5DeV4xmEurA9b4N8M7XVJ+kMY34d2bWsiVK1UHUonu0CAkgb3N/OPuxrn+ySColNK8FlYjWB9WLSvWemOth0M2W7T02HiIOJZyrzB0yIsfz9cc+PBXBgVaRvFni9xuwA5Y8zeQzFFQ7gqvXVO3MxMDzODzBwOjslLk+9pjYAbAzab3/hjbSk/zm4uSNwORPTaF585vjlLceamYLk2PIkbdQIxFU7XLcNUbmZCtYb3kRjvER3BnZ6VWmqwGHnBwH43+rvTcVoelALA+FQFMhmK+Iwcc3y/acWJqMqnYurKD7yIwWy/GhU8KVkJNhIVgDy3MfG2OckwcaKXabg1E0xUyVJDpPiJp1mTTe4OsTeL9JwsLkMwf93l/LwVf/djp2VzLuBSrKXMiNXdaGJMeAUlY8+vMSROCNLIU/wCjT+yPywccIPtHSc10cnp8JzfKlQ/u6v8A7sS/yFnT/uaH93U/92OtU8sg/wB2v9kfliZKI+wPgPyxfwcXw/t/gl4mT5/c4txHgmaSlUerSpKioSSquGEggRqqEbkcsFmI64cO2fDK9XLVEplACsEERPPcC2EF+HZ/lRpf3p/wYzZoRi1RbHKTWyetfnjRktviq3Ds/wD0NL+8P+DHn8n5/wDoqX94f8OI6+SqN65EH/O+EBuKvSqMtmUHbY7ciP44em4NnTulIf12/wAOF/jHYXMD6VIcx4lG8/szv6YfHV7BJutFPL8SpNerQSopPtCQ49ZME+4YPcCz+WpNqy6ozsNJSvCSCQYBJdSRA+eAnDuHg0AGBVtTTNiIYi492IsxlGXcSOuGcl0DfydFbjzjfIif2O7H3Fce0u0rc8tWX0Zv/Gvjkf8AJlRy2mInr12xt/IlXovxxVUTZ1wdqI/3WZH/ANtb8Kxxh7WjmuZHrVrf4zjkQ4JV/Z+P8Me/yJU/Z+P8MG0A6ue2CTEZmOve1I/7pxDX7W094rt5d9UH31Bjlv8AItTqvz/LHh4M/Vfn+WO0cdEz/ahKmkFCoHN6pYmeQ1VHj4DFH+VaJJJYCY5jkI64SRwZ+q/P8sT0eDJs9YIf3CRB8wcJKMe2PGT6Q3/yjQ/pU+OMwsjs7T/4qn8F/wAeMwvGHyPcvgameQR1BHxGEvI8DzNSNNJo6t4R/wBW/uwcTOFvCisx6KCfuw9ZetUZVlYOkSLWMX59cDlxEUbFbsz2aai5eqy3QrpWSRJBBkx9nphp4BwR6l6lWoVB8K6iIHuv7sW6NE9Bhg4f4VHpODB8nsM1xRDS4RTpgKigCRPnJgk9TvjfJJpZbQICn3g/iRghWUgecD4yPxxv+riooKg6WG3O+49QR8sWIlbhv0C7OCRenBZT1JEeGesjEOfzq1qyMFI0LBEhvaMC4kHnzxrXydSCp8X2dROn1I/DFzgvDdIYyWYkGYuYI5fH0EdMLQ1i8nDZKhFNw2v91DBt11FfngjQzzlHp1B3lOCvnpvA+UYNnI93Ds9NJJLa7+EkmANpvzwFzHGMtRLDL02r1GMy11FybKBEAk4XS7DtoUM7w00T3lQtTRn0BtP0YOmTq5FZm/K022v5fhtUQO7pEC6nSSp85WfmtsE81nq9VguZdGUgvose70gc+R8UR0wJyueq5Y/RHTTYyqsNSxy3nST1HpBwKS3R2+rDdDK1muadGdg2tio57FB9/TF1uzr1RDCm/mWYge4JA+IPngflu0eY6hTzK01a/mUBI/rRgnkuI980VK5qBRqIkATsAVXa/wBq/QcwU0Boi4f2MC1EfvXB1AhEdgrAXMgsbdT8LnDS9EKTBkdYMH/TFCpxCLJ4mcxItIFjH2UWY9/rgvQRGAES0QDz9PJbbfjho0noDd9kNMYtUV3xslIixH8cWEp4u2SoFcRXwH0wudx+0fhhv4hR8Bwr1qVzjNnL4iuaR+1jTuj1OJTT88eEepxks0UV6lJo6/DEdGk3P8MWnYDkfj/DEIrKDcwMdYaOeceqas1W8n0/2QF/DFComI2zQeo7z7TsfixP44m1YtREgp0QswN8bGMeVWviMtiiWib7JIxqxxrONW2wwDGOIzGBfGc8aekLubn0xWocRLW16T0IH34KRwfUDApu0FehUbQzBSbDl8CCp+GPdNXrPP2f4Yipu6kyuoHlH8I+WEyRtbVlsUnF2nQXTt5VjZD60x+DAfLHmBJp0zfuD8PyYDGYzeDj/lf2Nnjz/mX3OsZLIKggKAPIAYtKoE2xlMT1xIU8sGyFEeiTtzwVoNOkeQJ92LGR4EdIeqIkiFmDHMt+WNSBQBZ+vuttHW2NGNVshPeggKeoEyACBc7b/wAMUX4tlaJcNWZpMlVFgw5g8jblhJ7S9qHqMKYbSrGAokn1IXcemAjVhTaW01GU+JDJVlO8bFWFtuuOc37HKKR0XO/pAoCSKc+bXwH4n2/rWQAUdQJEiNrbDbaIwqZ3L0ToqUwU1EeFzYX+qR7Xvj34mq5YsZ0yzRd95LHZdwL84wPMzvKvYjrcaq1WR6zNpLeINIgAj4yJEeYw2doc8lHS9GhoXSCCF0a9QGk6R5iOuAH6h3b+Ma3iYG4n4Koj0nzOCmSpCrlmRlGqkSGKoTAa6M1QyXMwIjnywsk4q0GLsD8N1tZjJYk1D1JM6be0bCQPsgYY3oa1gjlebkjz5AeV/ditwzhFcorKgCkWIuSPlp9IwWoZCqv1YHOR+WKxiJJgSvSqJEKlRRtrWWUdAd7dME8nmgV1u4FJBqaLSY2gRAsfPfFyrSIkxI5gfePPywEztOPAB9EZn9kkWJHIAwdsBxo5Oxj4dmSQ9RrHYC3gWBpX3b+pOKnC+PvWc1lJ7qYQ8mUc/ebx0jAHildzSYLYFSWPkqRp9SflPXE3ZKutWklFDpIUBljTcDaTM/DC8g8ToWQ7UUydLEdL/P8Az5YYKJVhKm3rjny9gmJ1iuQTezSPmkfLF7L8Gz1H2HVx67/Ej7sUTkvYVqLG7PUfCd8LlXKzzxcy+czq2qUVceqiPKdTTjVgxGoroJ3WxjykHCZbY0KQNfKjrjZMtF5xLWnGqudrfHGai1kVSj54E53KT1ODj4rV6U4DSQybOR9oODNRY1KYOk3ZfxGKWWzAbbHS+I8N1TbHP+NcBqUWNSmpI+sAPmMUjNdMSUPdFOpUufXHms4onODGHN+R+GLkC8r41qVoGKYrsdgfgcau5PJv7J/LBAB+N1Jqx0AH4/jigRibMuTUYnqceIL4c43y+bdPZNuhuPhgjQ4lTb2xoPUXHw3HzwKIxrGAFOhlXLobh1I62xmFmMZgUNyPoHLVOgwU4ZQ1NJG3XkeojmMA8sC0C4ve/wCGGfKuFHl0xDHC3bKzlqkGKNIeuPc1k1YfwxUp5gE8v8x+OLP6xjQQZyn9IfZzu3StSLIHbS8MQoMWPO1ojqcCeHcCrnbMKp5ALuRciSJHrjqfafKivRZDsSJ9x3934YRlywpj6ZtQGwJ9xAUWaCNt4OAkrObYKy3CGSsrM7VGBmVII6iSQBPP2jg0tCHXUQg28JuSpDe1uSf2QDirk3qVZUeFaYIE3JDbQvK3X4Ykz9WmzGmH1MRDlNRctIlZG4tdV2k2x1Asi4lxRC7U6RAZULGb7XJIGxPmQZ5Y9yLU6Ly9RdLrDNUZoUmSrKiwCZU3tFsC62SWjXVAppIV0nYvpiCYuo5nn7sNXDeAM9Qlac0mplXqOd728TST1EbRywrja2MpU9GuUzIpKGq06ncNcV6ZZdM/aEwVk+1A3gnaW/JcMLoKqZp9B2LgRHvEkfHAX+VsvldKajma4lRJ8InlE6RsMUszWzOcViagLIxBy4JUwN/U+WBHSoaSvYw5jKVAJ1gjqaX4h8Aq1dXlS1Mkc/EpH343yHHXWmFpxC70n5funcYlbO0a3tDQeYddQHoRBHzxZbWyT+gCrUNMhalIA7gvY9ZBS/xxJk8sisCxQr0DNB9Qtj6HBVskB7C5dv3XKn4OB9+Nkpuolqvcr5Gl8tAJ+MYRwQykxx4RnBpFtIPONK+7UbyTywWWphC4ZmkRtaavOpVPjbqEn2B1bptho4bnxUXxSGJ8O4kdSOQNyPKMMnQGrClR8U64xQzvEqtKS1BtIMag8qffFvfgee0IM/RmPN/4YnOaKRxsvZgCb41VPQ4FVeOr9gf2/wCGLXC84tXVAgrHOd59OmMzLU0idxiFkxPUpxitUXA43o66K1WjfffFOvlhyNsXWUYrvTwfC+p3iA+pwxCbgHzg4gfhSDli6yDGa49Mc4NI5STYMPDUxBmOEoR0PyPr+eC7wf8AP+uIKj+Xy/LC7GpCRxfs3TeQRpbkwv8AH7Qwm8Q4U9Aw4sbBh7Lc7dD5HHXaxBsV/hjVOztbMIe7y5q0ydJ9mJHIgne4uMWjkfwTljXycWK48jHQ+K/oszw8VDLOR9gldQ9CTcet/XAs/o14r/wNT+0n+LF1si9CfGMxPxDKPQqPRqqUqIdLKdwRytbGYIDteTrANHS3lgtTzYi/vxmMwsfShpdk+Xzgi33c9vvxZOcgT1x5jMMKefrU264SMqFQGs5Op6jAc51MfCJ2+IFsZjMD3D7BD9UqVKdZ7U5UgAQXMWEn2VvO0+oxc4DwpEWnTChHcMJ31kH7W4spN9upx7jMNdCE/FstlMq4q1kNatyB9j4bH3zhc4/2rrVHpI8qlUwqpYBZAk8/d5YzGYn26K1S0R5R6mV71asd0zAEqBq8VlmQTpuLC8npgzk8g+ZUVKbaMzS8M/VqBbANHMRY4zGY6tgvReotTzJNOund5hLFlg/2tNm9d8bjs3mRbSlReRD6WHoSvyxmMxSJJ9WZU7PMtzUNPqDB+ag4t5TgdMA1CC+m+pjZQOgnUfljMZh2D4B9XLmsZ0xSsQDB7xTe4HsrzC+V+mC3CeJBKoptdVWR1GokRPlB+PXGYzE2OhmXidMysHoRFvS++FjtFkqVNe8pBgOYN1E7ESdQ9L+7HuMxOW0Vhpi8Kimfy/PF3gea01QJ9rw/l8xjMZiBo9hkcn/J/jiCoTjzGY6idldxiFhjMZg2zqRA6jELIMZjMdbDSNdA2H34hNCRbGYzCMZFOtSjl8z+eGTs12hoZegaVRXnWWGkSLgDmwPLbGYzDRdMEkEanbHKfYqxv7A2n/mdLYrJ2zyP2Ks9QgHIA/7znE/Dpj3GYo39BU5fLOF9ushVzHEMzXp0yUqVC6yVBg3EibYzGYzFebI8Ef/Z"
                        alt="Avatar"
                        className="w-24 h-24 rounded-full object-cover"
                    />
                    <div className="flex justify-between w-full">
                        <div>
                            {" "}
                            <h2 className="text-2xl font-bold mb-0">
                                [{manifestation.regroupement}] -{" "}
                                {manifestation.name} - {manifestation?.lieuRdv}{" "}
                                - {manifestation?.precisionRdv}
                                <h2 className="text-xl font-bold text-gray-900 mb-0">
                                    {formatTitre(
                                        manifestation.dateDebut,
                                        manifestation.dateFin
                                    )}
                                </h2>
                            </h2>
                            <p class="mb-1 text-gray-500 dark:text-gray-400 first-line:uppercase">
                                {"Précision lieu : " +
                                    manifestation.description}
                            </p>
                            <Info
                                label="Circuit"
                                value={manifestation.circuit}
                            />
                        </div>
                        <div className="p-4 bg-white rounded-xl border shadow-xs">
                            <div className="flex flex-col gap-2">
                                {[
                                    {
                                        label: "Billeterie",
                                        status: "Programmable",
                                    },
                                    {
                                        label: "Intégration",
                                        status: "À intégrer",
                                    },
                                ].map(({ label, status }, i) => (
                                    <div
                                        key={i}
                                        className="flex items-center gap-2"
                                    >
                                        <span className="text-sm font-medium text-gray-500 w-32">
                                            {label}
                                        </span>
                                        <span className="inline-flex items-center rounded-full bg-yellow-100 text-yellow-800 text-sm font-medium px-3 py-1">
                                            🟡 {status}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                {activeTab === "billeterie" && (
                    <>
                        {" "}
                        <Info
                            label="Date de mise en vente à la billeterie"
                            value={manifestation?.date_billeterie}
                        />
                        <Info
                            label="Canaux de vente"
                            value={manifestation.canauxVente.join(", ")}
                        />
                        <div>
                            <h2 class="font-medium text-gray-600 mr-1 text-sm">
                                Tarifs:
                            </h2>
                            <ul class="text-sm max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                                {manifestation.tarifs.map((tarif) => {
                                    return <li>{tarif}</li>;
                                })}
                            </ul>
                        </div>
                        <EspaceBilletterie donnees={donneesBilletterie} />
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold mb-2">
                                Commentaires
                            </h3>
                            <p className="text-sm text-gray-700 bg-gray-100 p-4 rounded-sm">
                                {manifestation.description}
                            </p>
                        </div>
                    </>
                )}

                {activeTab === "info" && (
                    <>
                        <div className="flex justify-between">
                            <div>
                                <StatCards
                                    cards={[
                                        {
                                            label: "Intervenants disponible",
                                            value: 2,
                                            icon: "👥",
                                            bg: "bg-blue-50",
                                            color: "text-blue-700",
                                        },
                                        {
                                            label: "Quotas",
                                            value: 20,
                                            icon: "🎯",
                                            bg: "bg-green-50",
                                            color: "text-green-700",
                                        },
                                        {
                                            label: "Billets vendus",
                                            value: 15,
                                            icon: "🎟️",
                                            bg: "bg-yellow-50",
                                            color: "text-yellow-700",
                                        },
                                        {
                                            label: "Taux de remplissage",
                                            value: (15 / 20) * 100 + "%", // tu peux passer un nombre + '%' ou une string déjà formatée
                                            icon: "%", // icône graphique simple
                                            bg: "bg-green-50", // fond vert clair pour un indicateur positif
                                            color: "text-green-700", // texte vert foncé
                                        },
                                    ]}
                                />
                                <div
                                    className={`mt-3 flex items-center gap-3 p-3 rounded-xl shadow-xs ${
                                        manifestation.accessibilite
                                            ? "bg-green-50 border border-green-200"
                                            : "bg-red-50 border border-red-200"
                                    }`}
                                >
                                    <svg
                                        className={`w-6 h-6 ${
                                            manifestation.accessibilite
                                                ? "text-green-600"
                                                : "text-red-600"
                                        }`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        {manifestation.accessibilite ? (
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M5 13l4 4L19 7"
                                            />
                                        ) : (
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M6 18L18 6M6 6l12 12"
                                            />
                                        )}
                                    </svg>
                                    <span
                                        className={`font-medium text-sm ${
                                            manifestation.accessibilite
                                                ? "text-green-800"
                                                : "text-red-800"
                                        }`}
                                    >
                                        {manifestation.accessibilite
                                            ? "Accessible aux personnes en situation de handicap"
                                            : "Non accessible aux personnes en situation de handicap"}
                                    </span>
                                </div>
                            </div>

                            <div>
                                {" "}
                                {contraintes.length > 0 && (
                                    <div className=" rounded-2xl border border-red-300 bg-red-50 p-4 shadow-xs">
                                        <div className="flex items-center mb-3">
                                            <svg
                                                className="h-5 w-5 text-red-500 mr-2"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M12 9v2m0 4h.01M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07"
                                                />
                                            </svg>
                                            <h3 className="text-lg font-semibold text-red-700">
                                                Contraintes
                                            </h3>
                                        </div>
                                        <ul className="list-disc pl-5 text-sm text-red-800 space-y-1">
                                            {contraintes.map((c, idx) => (
                                                <li key={idx}>{c}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>{" "}
                        <div>
                            <h2 class="font-medium text-gray-600 mr-1 text-sm">
                                {manifestation?.typeVisite} :
                            </h2>
                            <ul class="text-sm max-w-md space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
                                <li>{manifestation?.public}</li>
                                <li>{manifestation?.precisionPublic}</li>
                            </ul>
                        </div>
                        {/* Descriptif */}
                        <div className="mt-6">
                            <h3 className="text-lg font-semibold mb-2">
                                Commentaires
                            </h3>
                            <p className="text-sm text-gray-700 bg-gray-100 p-4 rounded-sm">
                                {manifestation.description}
                            </p>
                        </div>
                    </>
                )}

                {activeTab === "participants" && (
                    <>
                        {" "}
                        {manifestation?.intervenants?.length > 0 && (
                            <div className="mb-6">
                                <div className="flex justify-between">
                                    <div>
                                        <h3 className="text-lg font-semibold mb-4">
                                            Intervenants -{" "}
                                            {manifestation.langue.join(", ")}
                                        </h3>
                                    </div>
                                    <div>
                                        <span className="text-lg font-semibold mb-4">
                                            Surveillance
                                        </span>
                                        <span
                                            className={
                                                "m-2 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm"
                                            }
                                        >
                                            OUI
                                        </span>
                                    </div>
                                </div>
                                <div className="grid sm:grid-cols-2 lg:grid-cols-6 gap-4">
                                    {manifestation.intervenants.map(
                                        (intervenant, index) => (
                                            <div
                                                key={index}
                                                className="bg-white border border-gray-200 rounded-2xl shadow-xs p-4 flex flex-col items-center text-center"
                                            >
                                                <img
                                                    className="w-20 h-20 rounded-full object-cover mb-3"
                                                    src={
                                                        intervenant?.photo ||
                                                        "https://via.placeholder.com/80"
                                                    }
                                                    alt={intervenant?.nom}
                                                />
                                                <h4 className="text-base font-semibold text-gray-900">
                                                    {intervenant.nom}
                                                </h4>
                                                <p className="text-sm text-gray-500">
                                                    {intervenant.langue} –{" "}
                                                    {intervenant.phone}
                                                </p>
                                                <p className="text-sm text-gray-400 mb-2">
                                                    Public :{" "}
                                                    {intervenant.publics?.join(
                                                        ", "
                                                    ) || "—"}
                                                </p>
                                                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                                                    Préparation :{" "}
                                                    {intervenant.preparation}{" "}
                                                    min
                                                </span>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        )}
                        {/* Personnes disponibles */}
                        {manifestation?.disponibles?.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold mb-2">
                                    Personnes disponibles
                                </h3>
                                <ul className="flex flex-wrap gap-2">
                                    {manifestation.disponibles.map(
                                        (personne, index) => (
                                            <li
                                                key={index}
                                                className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm"
                                            >
                                                {personne}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                        {manifestation?.indisponibles?.length > 0 && (
                            <div className="mb-6">
                                <h3 className="text-lg font-semibold mb-2">
                                    Personnes Indisponibles
                                </h3>
                                <ul className="flex flex-wrap gap-2">
                                    {manifestation.indisponibles.map(
                                        (personne, index) => (
                                            <li
                                                key={index}
                                                className="bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm"
                                            >
                                                {personne}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                        )}
                    </>
                )}

                {activeTab === "historique" && (
                    <>
                        {" "}
                        <HistoriqueModifications
                            historique={[
                                {
                                    action: "Ajout d’un intervenant",
                                    utilisateur: "Marie Dupont",
                                    dateHeure: "27/05/2025 à 14h32",
                                    details:
                                        "Ajout de Paul Martin comme intervenant principal",
                                },
                                {
                                    action: "Modification des horaires",
                                    utilisateur: "Julien Bernard",
                                    dateHeure: "27/05/2025 à 09h15",
                                    details:
                                        "Heure de début modifiée de 9h00 à 10h00",
                                },
                                {
                                    action: "Création de l’activité",
                                    utilisateur: "Marie Dupont",
                                    dateHeure: "26/05/2025 à 17h45",
                                    details: "Création initiale de l’activité",
                                },
                            ]}
                        />
                    </>
                )}
            </div>
        </div>
    );
};
